import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { activeShellTab, shellTabs } from '@/constants/shellNavConfig';
import { cn } from '@/lib/utils';
import { ShellAccountMenu } from './ShellAccountMenu';
import { ShellBrandLogo } from './ShellBrandLogo';

/** Compact header below the desktop breakpoint. Destinations stay in a scrollable row. */
export function ShellMobileBar() {
  const { pathname } = useLocation();
  const activeTab = activeShellTab(pathname);

  return (
    <header className="shell-tab-bar lg:hidden flex flex-shrink-0 items-center gap-2 px-3">
      <ShellBrandLogo size="compact" className="flex-shrink-0" />
      <nav
        className="flex min-w-0 flex-1 items-center gap-1 overflow-x-auto"
        aria-label="Main"
      >
        {shellTabs.map((tab) => {
          const active = tab.id === activeTab;
          const Icon = tab.icon;
          return (
            <Link
              key={tab.id}
              to={tab.to}
              aria-current={active ? 'page' : undefined}
              className={cn(
                'shell-tab inline-flex h-11 flex-shrink-0 items-center gap-1.5 rounded-lg px-2.5 text-sm font-medium',
                active && 'shell-tab--active',
              )}
            >
              <Icon className="h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden />
              <span>{tab.shortLabel}</span>
            </Link>
          );
        })}
      </nav>
      <ShellAccountMenu compact />
    </header>
  );
}
